<template>
    <app-layout >
        <section class="bg-profile d-table w-100 bg-primary"
                 style="background: url('assets/images/account/bg.png') center center;">
            <div class="container">
                <div class="row mt-5 justify-content-center">
                    <div class="col-lg-12 text-center">
                        <div class="pages-heading"><h4 class="title text-white mb-0">Activate your account </h4></div>
                    </div><!--end col--></div><!--end row-->
            </div><!--end container--></section>
        <!-- Ec breadcrumb end -->

        <!-- Ec activation page -->
        <section class="ec-page-content section-space-p">
            <div class="container py-5">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="section-title">
                            <h2 class="ec-title">
                                Check your email for the activation link
                            </h2>
                            <p class="sub-title mb-3">
                                An activation link has been sent to <span>{{ auth.user('email') }}</span>
                            </p>
                            <p class="sub-title mb-3">
                                Please check your inbox and spam/junk folder for the activation email.
                            </p>
                        </div>
                    </div>
                    <div class="ec-login-wrapper">
                        <div class="ec-login-container">
<!--                            <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">-->
<!--                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>-->
<!--                                <strong>{{error}}</strong>-->
<!--                            </div>-->

                            <div v-if="success" class="alert alert-success alert-dismissible fade show" role="alert">
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="success = null"></button>
                                <strong>{{success}}</strong>
                            </div>

                            <div class="text-center">
                                <countdown @resend="resendActivationEmail"></countdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </app-layout>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import Countdown from "./countdown.vue";
import AppLayout from "../../app-layout.vue";

export default {
    inject: ['auth'],
    components: {
        AppLayout,
        Countdown
    },
    data() {
        return {
            error: null,
            success: null,
        }
    },
    watch: {
        '$user.value': function (user) {
            if(user?.data?.verified === true){
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
        '$userLoggedIn.value': function (newVal) {
            if(newVal === false){
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
    },
    created() {

        axios.post('resend_activation_email').then(response => {
            toast.success(response.data.message, { icon: 'fa-solid fa-envelope-circle-check',timeout: 3000});
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                this.error = error.response.data.message;
            } else {
                this.error = 'An error occurred while resending the email';
            }
            toast.error(this.error, { icon: 'fa-solid fa-exclamation-circle' ,timeout: 3000});
        });

    },
    methods: {
        resendActivationEmail() {
            const toastId = toast.info('Resending activation email...', { icon: 'fa-regular fa-envelope' });

            axios.post('resend_activation_email').then(response => {
                toast.dismiss(toastId);
                console.log(response.data);
                this.success = response.data.message;
                toast.success(response.data.message, { icon: 'fa-solid fa-envelope-circle-check',timeout: 3000 });
            }).catch(error => {
                console.error(error);
                toast.dismiss(toastId);
                if (error.response && error.response.data && error.response.data.message) {
                    this.error = error.response.data.message;
                } else {
                    this.error = 'An error occurred while resending the email';
                }
                toast.error(this.error, { icon: 'fa-solid fa-exclamation-circle',timeout: 3000 });
            });
        }
    },
}
</script>
